import { createGlobalStyle } from "styled-components";

export const Styles = createGlobalStyle`
    html {
        scroll-behavior: smooth;
    }

    body,
    html,
    a {
        font-family: "Source Sans 3", "Segoe UI", sans-serif;
    }

    body {
        margin: 0;
        padding: 0;
        border: 0;
        outline: 0;
        background: #ffffff;
        overflow-x: hidden;
        color: #1a3348;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-family: "Source Sans 3", "Segoe UI", sans-serif;
        color: #1a3348;
        line-height: 1.2;
    }

    p {
        color: #4b5d6b;
        font-size: 1.125rem;
        line-height: 1.65;
    }

    a {
        text-decoration: none;
        color: #1e5a8a;

        &:hover {
            color: #154266;
        }
    }

    a.MuiButton-root,
    a.MuiButton-root:hover,
    a.MuiButton-contained,
    a.MuiButton-contained:hover {
        color: #ffffff;
    }

    a.MuiButton-outlined,
    a.MuiButton-outlined:hover,
    a.MuiButton-text,
    a.MuiButton-text:hover {
        color: #1e5a8a;
    }

    :focus-visible {
        outline: 3px solid #1e5a8a;
        outline-offset: 3px;
    }

    #quiensomos,
    #cursos,
    #cursos1,
    #cursos2,
    #client,
    #libro,
    #contactos,
    [id^="curso-"],
    #catalogo {
        scroll-margin-top: 88px;
    }

    @media (min-width: 900px) {
        #quiensomos,
        #cursos,
        #cursos1,
        #cursos2,
        #client,
        #libro,
        #contactos,
        [id^="curso-"],
        #catalogo {
            scroll-margin-top: 112px;
        }
    }

    @media print {
        header, footer, .MuiAppBar-root, .MuiDrawer-root, button {
            display: none !important;
        }

        .curso-ticket {
            box-shadow: none !important;
        }
    }

    @media (prefers-reduced-motion: reduce) {
        html {
            scroll-behavior: auto;
        }

        *,
        *::before,
        *::after {
            animation-duration: 0.01ms !important;
            animation-iteration-count: 1 !important;
            transition-duration: 0.01ms !important;
        }
    }
`;
